import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase } from 'vnpost-shared';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { CommissionQualityService } from '../../services/commission-quality.service';


@Component({
  selector: 'app-create-commission-for-stage',
  templateUrl: './create-commission-for-stage.component.html',
  styleUrls: ['./create-commission-for-stage.component.scss']
})
export class CreateCommissionForStageComponent extends SecondPageEditBase
implements OnInit
{
listStatus: { label: string; value: number }[] = [
  { label: 'Đang áp dụng', value: 1 },
  { label: 'Ngừng áp dụng', value: 0 },
];

constructor(
  protected _service: CommissionQualityService,
  protected _injector: Injector,
) {
  super(_service, _injector);
  this.formGroup = new UntypedFormGroup({
    stageCode: new UntypedFormControl('', [Validators.required]),
    stageName: new UntypedFormControl('', [Validators.required]),
    commission_rate: new UntypedFormControl(''),
    status: new UntypedFormControl(''),
    notes: new UntypedFormControl(''),
  });
}

ngOnInit() {
}

onShowPopup() {
  this.validationSummary.resetErrorMessages();
  this.resetForm();
  this.onReset();

  this.itemDetail.id = 0;
  this.itemDetail.status = 1;
}

async save() {
  this.submitting = true;

  if (this.formGroup.invalid) {
    this.submitting = false;
    this.validationSummary.showValidationSummary();
    return;
  }
  
  this.onInsert();
}

onInsert() {
  this._service.create(this.itemDetail).then(
    (response) => {
      this.closePopupMethod(true);
      this._notifierService.showInsertDataSuccess();
      this.onAfterSave();
      this.submitting = false;
    },
    (error) => {
      this._notifierService.showInsertDataFailed();
      this.submitting = false;
    }
  );
}
}
